import { get } from '../utilities/api'

export const getContent = slug => get({
  url: `/content${slug}`
})

export const getContents = params => get({
  url: '/contents',
  params
})

export const getContentsSearch = params => get({
  url: '/content/search',
  params
})

export const getTemplate = id => get({
  url: `/templates/${id}`
})
